import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';
import { Section, SectionImage } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';

const INTERIOR_GENERAL_KEYS = [
  'radio_turns_on',
  'interior_vehicle_odor',
  'keys',
  'air_conditioning',
  'heater',
  'interior_overall',
] as const;

export const useInteriorGeneralSection = (): { section: Section | undefined; images: SectionImage[] } => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);
  const { subSections, images } = useLevel1SectionData('interior_questions');

  const rawSection = sections?.interior_questions;
  const subsections: Record<string, Section> = {};
  INTERIOR_GENERAL_KEYS.forEach(key => {
    const sub = subSections[key];
    if (sub?.grade) subsections[key] = sub;
  });

  return {
    section: rawSection ? { ...rawSection, subsections } : undefined,
    images: images.slice(1), // index 0 is the odometer image, shown in Dash
  };
};
